module.exports = __webpack_public_path__ + "media/images/river/crewneck-storm-b5ed5003f98008a1ba9dd9835f54283b.jpg";